import styled from 'styled-components';

export const TermContentWrapper = styled.div`
  h1{
    font-weight: 700;
    font-style: normal;
    text-transform: none;
    font-size: 42px;
    line-height: 54px;
    letter-spacing: -1px;
    color: #303132;
    margin-bottom: 40px;
  }

  div.ant-typography > p, li {
    color: #878787;
    margin-bottom: 30px;
    line-height: 29px;
    letter-spacing: 0;
    font-size: 17px;
    font-style: normal;
    font-weight: 200px;
  }
`;
